import groupColumns from './groups';
import userColumns from './users';
import barnColumns from './barns';
import binColumns from './bins';
import farmColumns from './farms';

export default function getTableColumns(type, status, measurementSystem) {
  const columns = {
    groups: groupColumns(status),
    users: userColumns(status),
    barns: barnColumns(status),
    bins: binColumns(status, measurementSystem),
    farms: farmColumns(status),
    companies: farmColumns(status),
  };
  return columns[type];
}
